module.exports = __webpack_public_path__ + "img/pop_1.80881d40.png";